import { AfterViewInit, Component, EventEmitter, Inject, Input, Output, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { take } from 'rxjs/operators';
import { IFilters } from '../../../../../shared/interfaces/filters/filters.interface';
import { FiltersSettingsRef } from '../../../constants/filters-settings-ref.token.const';
import { IFiltersSettings } from '../../../interfaces/filters-settings.interface';
import { FiltersChannel } from '../../../models/filters-channel.model';
import { FiltersSidenavService } from '../../../services/filters-sidenav.service';
import { EditFiltersComponent } from '../edit-filters/edit-filters.component';

@Component({
  standalone: false,
  selector: 'suvo-bi-filters-content',
  templateUrl: './filters-content.component.html',
  styleUrls: ['./filters-content.component.scss'],
})
export class FiltersContentComponent implements AfterViewInit {
  @ViewChild('editFiltersRef') editFiltersRef: EditFiltersComponent;

  @Input() filtersChannel: FiltersChannel;
  @Input() selectOpen = false;
  @Input() showNoneOption = true;
  @Input() autoApplyFilters = true;
  @Input() showExportButton = true;
  @Input() insertStyles: any = {};
  @Input() filtersChannelSuffiix = '';
  @Input() autoSave = true;
  @Input() isSidenavContent = false;
  @Input() exportDisabled = true;
  @Input() showFilterHeader = true;
  @Input() editFiltersHeading = 'Configure filters';

  @Output() filtersManuallyApplied = new EventEmitter<boolean>();

  selectedFilters: IFilters;
  createEvent = new EventEmitter<boolean>();

  currentExportRoute = null;
  onExportScreen = false;

  constructor(
    private activatedRoute: ActivatedRoute,
    public filtersSidenavService: FiltersSidenavService,
    @Inject(FiltersSettingsRef) private filtersSettings: IFiltersSettings,
  ) {}

  ngAfterViewInit() {
    this.currentExportRoute =
      this.filtersSettings?.filtersSections?.[this.filtersChannel?.channelName]?.exportRoute;
    this.activatedRoute.url.pipe(take(1)).subscribe((route) => {
      if (route[0]?.path === 'export') {
        this.onExportScreen = true;
      } else {
        this.onExportScreen = false;
      }
    });
  }

  onClose() {
    this.filtersSidenavService.close();
  }

  saveTemporaryFilters() {
    this.editFiltersRef.saveTemporaryFilters();
  }

  discardTemporaryFilters() {
    this.editFiltersRef.discardTemporaryFilters();
  }

  applyFiltersClicked() {
    this.editFiltersRef.applyFiltersClicked();
  }

  clearFilters() {
    this.editFiltersRef.clear();
  }
}
